---
fr:
  labels:
    apply: Appliquer
    clear: Effacer
    labels: Étiquette
